import { h } from '../../utils/dom.js';
import { t } from '../../i18n/index.js';

export function Loader({ message } = {}) {
  return h('div', { class: 'state-block' },
    h('div', { class: 'spinner' }),
    h('p', {}, message || t('loading'))
  );
}
